module.exports = __webpack_public_path__ + "img/emm_icon06.ff508cc1.png";